import { render, staticRenderFns } from "./ActivitiesHeader.vue?vue&type=template&id=2d26c27a&"
import script from "./ActivitiesHeader.vue?vue&type=script&lang=js&"
export * from "./ActivitiesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports